import React from 'react'
import "./app.css"
import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home'
import Popular from './Components/Popular/Popular'
import Offer from './Components/Offers/Offer'
import About from './Components/About/About'
import Blog from './Components/Blog/Blog'
import ScrollToTopButton from './Components/ScrollTop'



const HomePage = () => {
    return (
      <>
        <Navbar/>
        <Home/>
        <Popular/>
        <Offer/>
        <About/>
        <Blog/>
        <ScrollToTopButton/>
      </>
  )
}

export default HomePage